import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/Home';
import Calculators from '@/components/Calculators';
import BitcoinCalc from '@/components/BitcoinCalc';
import AltcoinCalc from '@/components/AltcoinCalc';
import AltcoinPath from '@/components/AltcoinPath';
import SettingsExchanges from '@/components/SettingsExchanges';
import SettingsCurrency from '@/components/SettingsCurrency';


Vue.use(Router)

export default new Router({
	routes: [

	         {
	        	 path: '/',
	        	 name: 'Home',
	        	 component: Home,
	        	 meta: {title: 'Crypto currency tools, calculators, path finder, deals, and stuff.'}
	         },
	         {
	        	 path: '/settings/exchanges',
	        	 name: 'SettingsExchanges',
	        	 component: SettingsExchanges,
	        	 meta: {title: 'Set preferred exchanges'}
	         },
	         {
	        	 path: '/settings/currency',
	        	 name: 'SettingsCurrency',
	        	 component: SettingsCurrency,
	        	 meta: {title: 'Set preferred currency'}
	         },
	         {
	        	 path: '/calculators/',
	        	 name: 'Calculators',
	        	 component: Calculators,
	        	 meta: {title: 'Bitcoin and Altcoin Calculators'}
	         },
	         {
	        	 path: '/calculators/bitcoin',
	        	 name: 'BitcoinCalc',
	        	 component: BitcoinCalc,
	        	 meta: {title: 'Bitcoin to Fiat Calculator'}
	         },
	         {
	        	 path: '/calculators/altcoin',
	        	 name: 'AltcoinCalc',
	        	 component: AltcoinCalc,
	        	 meta: {title: 'Altcoin to Fiat Calculator'}
	         },
	         {
	        	 path: '/paths/altcoin',
	        	 name: 'AltcoinPath',
	        	 component: AltcoinPath,
	        	 meta: {title: 'Altcoin Path Finder'}
	         }
	         ]
})





// WEBPACK FOOTER //
// ./src/router/index.js